export function isNotificationSupported() {
  return 'Notification' in window
}

export function getNotificationPermission() {
  if (!isNotificationSupported()) return 'unsupported'
  return Notification.permission
}

export function maskToken(token) {
  if (!token) return ''
  if (token.length <= 20) return token
  return `${token.substring(0, 10)}...${token.substring(token.length - 10)}`
}

export function getPermissionColor(permission) {
  const colors = {
    default: 'grey',
    granted: 'positive',
    denied: 'negative',
    unsupported: 'negative',
  }
  return colors[permission] || 'grey'
}

export function getTokenStatusColor(tokenStatus) {
  const colors = {
    none: 'grey',
    fetched: 'warning',
    'sent-to-backend': 'positive',
    'cached-valid': 'positive',
    error: 'negative',
  }
  return colors[tokenStatus] || 'grey'
}
